module.exports = __webpack_public_path__ + "static/media/Freddy-Jumpscare.d39468d3.webp";